import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { colorComponents, isColorBright, RGB_2_HEX } from '../../lib/ep';

import Loader from './Loader';

const Spinner = (props) => {
	const is_transparent = props?.is_transparent ?? true;
	const color = props?.color ?? 'var(--text-color)';

	let styles = props?.style ?? {};
	if(color !== false) {
		const color_components = colorComponents(color);
		try {
			styles['--button-text-color'] = `${color_components[0]}, ${color_components[1]}, ${color_components[2]}`;
			styles['--main-text-color'] = `${color_components[0]}, ${color_components[1]}, ${color_components[2]}`;
		} catch (error) {
			
		}
		
	}
	const [ item_styles, setItemStyles ] = useState(styles);

	let classname = props?.classname ?? 'gui_loading';
	const classes = classname.split(" ");

	if(props._class) {
		for(var i in props._class) {
			switch(i) {
				case 'fullscreen':
					if(props._class['fullscreen']) classes.push('is_fullscreen');
					break;

				case 'h_position':
					switch(props._class[i]) {
						case 'left':
							classes.push('gui_flex_start');
							break;

						case 'right':
							classes.push('gui_flex_end');
							break;
					}
					break;

				default:
					classes.push(props._class[i]);
					break;
			}
		}
	}

	if(is_transparent && (props.force_bg == undefined || !props.force_bg)) classes.push('is_transparent');
	if(!props.children) classes.push('without_text');
	classname = classes.join(" ");

	let message = false;
	if(props.children != undefined) {
		message = ((props.autotranslate == undefined || props.autotranslate) && typeof props.children == 'string') ? props.intl.formatMessage({id:props.children}) : props.children;
	}

	useEffect(() => {
		if(color !== false) return;

		setTimeout(() => {
			const loading_item = document.querySelector('.gui_loading');
			if(loading_item != undefined) {
				const spinner_bg = getComputedStyle(loading_item);

				const bg_color_front = spinner_bg.getPropertyValue('--container-background-color');
				if(bg_color_front != '') {
					// var(--container-background-color) is defined, so we're on frontend

					const color_parts = bg_color_front.replace(" ", "").split(",");
					if(parseFloat(color_parts[3]) < 0.5) {
						// very light opacity background

						const color_var = `rgba(${spinner_bg.getPropertyValue('--button-text-color')})`;
						const is_color_var_light = (isColorBright(RGB_2_HEX(color_var))) ? true : false;

						setItemStyles({...item_styles, '--container-background-color-rgb':(is_color_var_light) ? '0, 0, 0' : '255, 255, 255' });
					}
				}
			}
		}, 0);
	}, []);

	const hide_spinner = props?.hide_spinner ?? false;

	return (
		<aside class={classname} style={item_styles}>
			<div>
				{(message) && (
					<span class="gui_center_aligned gui_text_block in_bottom" style={{ width:'100%' }}>{message}</span>
				)}

				{(!hide_spinner) && (
					<Loader />
				)}
			</div>
		</aside>
	)
}

export default injectIntl(Spinner);